import React, { useContext } from 'react';
import { Routes, Route } from 'react-router-dom';
import CoreRouter from './CoreRouter';
import AdminRouter from './AdminRouter';
import BlogRouter from './BlogRouter';
import CoreLayout from './CoreLayout';
import AdminLayout from './AdminLayout';
import BlogLayout from './BlogLayout';
import AuthContext from '../authentication/components/AuthProvider';

const AppRouter = () => {
  const { userLogout, isAuthenticated } = useContext(AuthContext);
  //const { userLogout, isAuthenticated } = { userLogout: () => {}, isAuthenticated: true };

  return (
    <Routes>
      <Route 
        path="/*" 
        element={
          <CoreLayout userLogout={userLogout}>
            <CoreRouter />
          </CoreLayout>
        } 
      />
      <Route 
        path="/blog/*" 
        element={
          <BlogLayout userLogout={userLogout}>
            <BlogRouter />
          </BlogLayout>
        } 
      />
      <Route 
        path="/admin/*" 
        element={
          <AdminLayout userLogout={userLogout} isAuthenticated={isAuthenticated}>
            <AdminRouter />
          </AdminLayout>
        } 
      />
    </Routes>
  );
};

export default AppRouter;